export const OrgType = {
  Kunde: "Kunde",
  Leverandoer: "Leverandør",
  Konsortium: "Konsortium",
  Indkoebsfaellesskab: "Indkøbsfællesskab",
  SKI: "SKI",
}
